import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

/** Fields from GET /Appoinment/{id} needed for digital VOS sign-in section. */
export function mergeCheckInAuditFromAppointment(
  existing: Record<string, unknown> | null | undefined,
  fetched: Record<string, unknown> | null | undefined
): Record<string, unknown> {
  const prev = existing ?? {}
  const data = fetched ?? {}
  return {
    ...prev,
    checkedInAt: data.checkedInAt ?? data.CheckedInAt ?? prev.checkedInAt ?? prev.CheckedInAt,
    checkOutAt: data.checkOutAt ?? data.CheckOutAt ?? prev.checkOutAt ?? prev.CheckOutAt,
    checkInStaffName:
      data.checkInStaffName ?? data.CheckInStaffName ?? prev.checkInStaffName ?? prev.CheckInStaffName,
    checkInStaffEmail:
      data.checkInStaffEmail ?? data.CheckInStaffEmail ?? prev.checkInStaffEmail ?? prev.CheckInStaffEmail,
    checkInStaffNumber:
      data.checkInStaffNumber ?? data.CheckInStaffNumber ?? prev.checkInStaffNumber ?? prev.CheckInStaffNumber,
    checkInStaffSignUrl:
      data.checkInStaffSignUrl ?? data.CheckInStaffSignUrl ?? prev.checkInStaffSignUrl ?? prev.CheckInStaffSignUrl,
    timeZoneZone: data.timeZoneZone ?? data.TimeZoneZone ?? prev.timeZoneZone ?? prev.TimeZoneZone,
    timeZoneName: data.timeZoneName ?? data.TimeZoneName ?? prev.timeZoneName ?? prev.TimeZoneName,
    fK_TimeZone: data.fK_TimeZone ?? data.FK_TimeZone ?? prev.fK_TimeZone ?? prev.FK_TimeZone,
  }
}

export async function fetchAppointmentCheckInAudit(
  appointmentId: string | number
): Promise<Record<string, unknown>> {
  const response = await axios.get(`${API_URL}/Appoinment/${appointmentId}`)
  return (response.data ?? {}) as Record<string, unknown>
}

export function hasCheckInStaffAudit(appt: Record<string, unknown> | null | undefined): boolean {
  if (!appt) return false
  return Boolean(
    appt.checkInStaffName ??
      appt.CheckInStaffName ??
      appt.checkInStaffEmail ??
      appt.CheckInStaffEmail ??
      appt.checkInStaffSignUrl ??
      appt.CheckInStaffSignUrl
  )
}
